export { default } from "./DisplayData";
